// extracted by mini-css-extract-plugin
export default {"image-container":"Image_image-container__AgL3b","skeleton":"Image_skeleton__oGO-G","skeleton-loading":"Image_skeleton-loading__u-GbW"};